export const APIV2_URL = '/api/v2';
